export const HOST_PATHNAME = 'https://jetvix.com/' as const;

export const LOAD_PARTNER_CAMPAIGNS_START = 'LOAD_PARTNER_CAMPAIGNS_START' as const;
export const LOAD_PARTNER_CAMPAIGNS_SUCCESS = 'LOAD_PARTNER_CAMPAIGNS_SUCCESS' as const;
export const LOAD_PARTNER_CAMPAIGNS_FAILURE = 'LOAD_PARTNER_CAMPAIGNS_FAILURE' as const;

export const ADD_PARTNER_CAMPAIGN_START = 'ADD_PARTNER_CAMPAIGN_START' as const;
export const ADD_PARTNER_CAMPAIGN_SUCCESS = 'ADD_PARTNER_CAMPAIGN_SUCCESS' as const;
export const ADD_PARTNER_CAMPAIGN_FAILURE = 'ADD_PARTNER_CAMPAIGN_FAILURE' as const;

export const UPDATE_PARTNER_CAMPAIGN_START = 'UPDATE_PARTNER_CAMPAIGN_START' as const;
export const UPDATE_PARTNER_CAMPAIGN_SUCCESS = 'UPDATE_PARTNER_CAMPAIGN_SUCCESS' as const;
export const UPDATE_PARTNER_CAMPAIGN_FAILURE = 'UPDATE_PARTNER_CAMPAIGN_FAILURE' as const;

export const DELETE_PARTNER_CAMPAIGN_START = 'DELETE_PARTNER_CAMPAIGN_START' as const;
export const DELETE_PARTNER_CAMPAIGN_SUCCESS = 'DELETE_PARTNER_CAMPAIGN_SUCCESS' as const;
export const DELETE_PARTNER_CAMPAIGN_FAILURE = 'DELETE_PARTNER_CAMPAIGN_FAILURE' as const;

export const UPDATE_PARTNER_PAYMENT_START = 'UPDATE_PARTNER_PAYMENT_START' as const;
export const UPDATE_PARTNER_PAYMENT_SUCCESS = 'UPDATE_PARTNER_PAYMENT_SUCCESS' as const;
export const UPDATE_PARTNER_PAYMENT_FAILURE = 'UPDATE_PARTNER_PAYMENT_FAILURE' as const;

export const LOAD_PARTNER_STATISTICS_START = 'LOAD_PARTNER_STATISTICS_START' as const;
export const LOAD_PARTNER_STATISTICS_SUCCESS = 'LOAD_PARTNER_STATISTICS_SUCCESS' as const;
export const LOAD_PARTNER_STATISTICS_FAILURE = 'LOAD_PARTNER_STATISTICS_FAILURE' as const;

export const SET_PARTNER_PARAMS = 'SET_PARTNER_PARAMS' as const;
export const ACCEPT_PARTNER_RULES = 'ACCEPT_PARTNER_RULES' as const;

export const LOAD_PARTNER_POSTBACKS_START = 'LOAD_PARTNER_POSTBACKS_START' as const;
export const LOAD_PARTNER_POSTBACKS_SUCCESS = 'LOAD_PARTNER_POSTBACKS_SUCCESS' as const;
export const LOAD_PARTNER_POSTBACKS_FAILURE = 'LOAD_PARTNER_POSTBACKS_FAILURE' as const;

export const ADD_PARTNER_POSTBACK_START = 'ADD_PARTNER_POSTBACK_START' as const;
export const ADD_PARTNER_POSTBACK_SUCCESS = 'ADD_PARTNER_POSTBACK_SUCCESS' as const;
export const ADD_PARTNER_POSTBACK_FAILURE = 'ADD_PARTNER_POSTBACK_FAILURE' as const;

export const UPDATE_PARTNER_POSTBACK_START = 'UPDATE_PARTNER_POSTBACK_START' as const;
export const UPDATE_PARTNER_POSTBACK_SUCCESS = 'UPDATE_PARTNER_POSTBACK_SUCCESS' as const;
export const UPDATE_PARTNER_POSTBACK_FAILURE = 'UPDATE_PARTNER_POSTBACK_FAILURE' as const;

export const DELETE_PARTNER_POSTBACK_START = 'DELETE_PARTNER_POSTBACK_START' as const;
export const DELETE_PARTNER_POSTBACK_SUCCESS = 'DELETE_PARTNER_POSTBACK_SUCCESS' as const;
export const DELETE_PARTNER_POSTBACK_FAILURE = 'DELETE_PARTNER_POSTBACK_FAILURE' as const;

export const RESET_ADD_PARTNER_POSTBACK_ERROR = 'RESET_ADD_PARTNER_POSTBACK_ERROR' as const;
export const RESET_UPDATE_PARTNER_POSTBACK_ERROR = 'RESET_UPDATE_PARTNER_POSTBACK_ERROR' as const;

export const REFRESH_API_KEY_START = 'REFRESH_API_KEY_START' as const;
export const REFRESH_API_KEY_SUCCESS = 'REFRESH_API_KEY_SUCCESS' as const;
export const REFRESH_API_KEY_FAILURE = 'REFRESH_API_KEY_FAILURE' as const;
